import React, { useState, useEffect } from "react";
import "../styles/Navbar.css";

const LINKS = [
  { id: "home",     label: "Home" },
  { id: "about",    label: "About" },
  { id: "services", label: "Services" },
  { id: "projects", label: "Projects"},
  { id: "packages", label: "Packages" },
  { id: "contact",  label: "Contact" },
];

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [active,   setActive]   = useState("home");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const onScroll = () => {
      const sections = document.querySelectorAll("section[id]");
      sections.forEach((sec) => {
        const top    = window.scrollY;
        const offset = sec.offsetTop - 130;
        const height = sec.offsetHeight;
        if (top >= offset && top < offset + height) setActive(sec.id);
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const onResize = () => { if (window.innerWidth >= 768) setMenuOpen(false); };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const close = () => setMenuOpen(false);

  return (
    <>
      <nav className={`navbar ${scrolled ? "navbar--scrolled" : ""}`}>
        <div className="navbar-inner">

          {/* Logo */}
          <a href="#home" className="logo" onClick={close} aria-label="Codix Tech">
            <span className="logo-bracket">&lt;</span>
            <span className="logo-c">C</span>
            <span className="logo-odix">odix</span>
            <span className="logo-slash">/</span>
            <span className="logo-bracket">&gt;</span>
          </a>

          {/* Desktop links */}
          <ul className="nav-links" role="list">
            {LINKS.map(({ id, label }) => (
              <li key={id}>
                <a
                  href={`#${id}`}
                  className={`nav-link ${active === id ? "nav-link--active" : ""}`}
                  aria-current={active === id ? "page" : undefined}
                >
                  {label}
                  <span className="nav-underline" aria-hidden="true" />
                </a>
              </li>
            ))}
          </ul>

          {/* Desktop CTA */}
          <a
            href="https://book.codixlb.com"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-cta"
          >
            Free Consultation
          </a>

          {/* Hamburger */}
          <button
            className={`hamburger ${menuOpen ? "hamburger--open" : ""}`}
            onClick={() => setMenuOpen((o) => !o)}
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            aria-expanded={menuOpen}
          >
            <span className="bar" />
            <span className="bar" />
            <span className="bar" />
          </button>
        </div>
      </nav>

      {/* Mobile drawer */}
      <div
        className={`mobile-drawer ${menuOpen ? "mobile-drawer--open" : ""}`}
        aria-hidden={!menuOpen}
      >
        <ul role="list">
          {LINKS.map(({ id, label }, i) => (
            <li key={id}>
              <a
                href={`#${id}`}
                className={`mobile-link ${active === id ? "mobile-link--active" : ""}`}
                onClick={close}
              >
                <span className="mobile-num">{String(i + 1).padStart(2, "0")}.</span>
                {label}
              </a>
            </li>
          ))}
        </ul>
        <a
          href="https://book.codixlb.com"
          target="_blank"
          rel="noopener noreferrer"
          className="mobile-cta"
          onClick={close}
        >
          Book Free Consultation →
        </a>
      </div>

      {menuOpen && (
        <div className="drawer-backdrop" onClick={close} aria-hidden="true" />
      )}
    </>
  );
}

export default Navbar;
